<script>
import Layout from "../../layouts/main";
import ExportButton from "@/components/export-button";
import axios from "@/axios";
import DPConfig from "../../../components/dataPickerConf";
import WebPayModal from "@/components/web-pay-modal/web-pay-modal";
import Filter from "@/components/filters/Filter";
import { formatCurrency } from "@/utils";

export default {
  components: {
    Layout,
    WebPayModal,
    "export-button": ExportButton,
    filters: Filter,
  },
  data() {
    return {
      lang: {
        formatLocale: DPConfig.formatLocale,
      },
      datosBoleta: this.$store.getters["docs/boletaFactura"],
      rutEmpresa: this.$store.getters["rutEmpresa/cuentaSeleccionada"].value,
      numeroDocumento: parseInt(this.$route.params.id),
      filtersValue: {
        rutEmpresa: "",
        numeroContrato: "",
      },
      fields: [
        {
          key: "estadoDePago",
          label: "ID estado pago",
          sortable: false,
        },
        {
          key: "mes",
          label: "Fecha de periodo",
          sortable: false,
        },
        {
          key: "totalFlota",
          label: "Total con IVA",
          sortable: false,
        },
        {
          key: "descarga",
          label: "Descarga",
          sortable: false,
        },
        {
          key: "pagar",
          label: "Pagar",
          sortable: false,
        },
      ],
      tableData: [],
      isBusy: true,
      buttonClicked: undefined,
    };
  },
  beforeMount() {
    this.getEstadoPago();
  },
  methods: {
    getEstadoPago() {
      if (this.filtersValue.rutEmpresa) {
        this.isBusy = true;
        axios
          .get("/GetEstadoPagoLop", { params: this.getQuery() })
          .then((docs) => {
            this.tableData = docs.data.datos;
            this.isBusy = false;
          })
          .catch((error) => {
            if (error.response) {
              this.$bvToast.toast(this.$t("NoData.error.message").toString(), {
                title: this.$t("NoData.error.title").toString(),
                variant: "danger",
                solid: true,
              });
            }
            this.isBusy = false;
          });
      }
    },
    getQuery() {
      if (this.filtersValue.numeroContrato){
        return {
          rutEmpresa: this.filtersValue.rutEmpresa,
          numeroContrato: this.filtersValue.numeroContrato,
          pagina: 1,
          registros: 10,
        };
      } else {
        return {
          rutEmpresa: this.filtersValue.rutEmpresa,
          pagina: 1,
          registros: 10,
        };
      }
    },
    getCurrency(inport) {
      return formatCurrency(inport);
    },
    downloadDocumento(row) {
      this.buttonClicked = row.item.estadoDePago;
      axios
        .get(`/DescargarDocumentoDeContrato?id=${this.buttonClicked}`)
        .then((documento) => {
          if (documento.data.pdf) {
            const blob = this.b64toBlob(documento.data.pdf, "application/pdf");
            let fileURL = window.URL.createObjectURL(blob);
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", `${this.buttonClicked}.pdf`);
            document.body.appendChild(fileLink);

            fileLink.click();
            this.buttonClicked = undefined;
          }
        })
        .catch(() =>
          this.$bvToast.toast(this.$t("lease.pdf.error.nonFound").toString(), {
            title: this.$t("lease.pdf.error.download").toString(),
            variant: "danger",
            solid: true,
          })
        );
      this.isBusy = false;
    },
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, {type: contentType});
    },
  },
};
</script>
<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center" class="mb-3">
              <h4 class="card-tittle">Estados de Pago</h4>
              <export-button :data="tableData" fileName="documentos" />
            </b-row>
            <filters v-model="filtersValue" @change="getEstadoPago" />
            <div class="container">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :busy="isBusy"
                class="text-center"
                show-empty
              >
                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->

                <template>
<!--                  <h5-->
<!--                    v-if="!filtersValue.numeroContrato"-->
<!--                    style="text-align: center"-->
<!--                  >-->
<!--                    {{-->
<!--                      $t("request.table.required", {-->
<!--                        type: "el numero de contrato",-->
<!--                      })-->
<!--                    }}-->
<!--                  </h5>-->
                  <h5 style="text-align: center">
                    {{ $t("request.table.empty") }}
                  </h5>
                </template>

                <template #cell(descarga)="row">
                  <div class="text-center" :id="`estado-pago-${row.item.estadoDePago}`">
                    <b-button variant="danger" @click="downloadDocumento(row)" :disabled="!row.item.estadoDePago">
                      <i
                        v-if="buttonClicked !== row.item.estadoDePago"
                        class="bx bx-download font-size-16 align-middle"
                      />
                      <b-spinner v-else small class="align-middle"></b-spinner>
                      Descargar
                    </b-button>
                    <b-tooltip :target="`estado-pago-${row.item.estadoDePago}`" triggers="hover" placement="rigth" v-if="!row.item.estadoDePago">
                      No existen documentos disponibles
                    </b-tooltip>
                  </div>
                </template>

                <template #cell(pagar)="row">
                  <WebPayModal :index="row.index" :document="row.item" />
                </template>
                <template #cell(totalFlota)="row">
                  {{ "$" + getCurrency(row.value) }}
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
</style>
